import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"]
})
export class HeaderComponent implements OnInit {
  constructor(
    private readonly router: Router,
  ) {}

  ngOnInit() {}

  public isPeopleRouteActive(): boolean {
    const URL = "/home/people";
    return this.router.isActive(this.router.parseUrl(URL), false);
  }

  public isCommoditiesRouteActive(): boolean {
    const URL = "/home/commodities";
    return this.router.isActive(this.router.parseUrl(URL), false);
  }
}
